module.exports = __webpack_public_path__ + "img/canadian-flag.954f7762.svg";